import React from 'react';
import { View, FlatList, TouchableOpacity, Text, StyleSheet } from 'react-native';
import { options } from 'yargs';
import {
  GAME_TYPES_TYPE,
  operandText,
  GAME_TYPES_CONFIG,
  GAME_TYPE_ARRANGEMENT,
} from '../../constants/constants';

type TGameDropDownScrollProps = {
  setShowDropdown: (value: boolean) => void;
  setGameSelected: (game: GAME_TYPES_TYPE | 'All') => void;
  dropDownItemColor?: string;
};

export default function GameDropDownScroll(props: TGameDropDownScrollProps) {
  const { setShowDropdown, setGameSelected, dropDownItemColor = '#FEDD88' } = props;
  const options: (GAME_TYPES_TYPE | 'All')[] = ['All', ...GAME_TYPE_ARRANGEMENT];
  return (
    <>
      <View style={styles.dropdownContainer}>
        <FlatList
          data={options}
          keyExtractor={item => item.toString()}
          nestedScrollEnabled={true}
          keyboardShouldPersistTaps="handled"
          renderItem={({ item }: { item: GAME_TYPES_TYPE | 'All' }) => (
            <TouchableOpacity
              style={[styles.dropdownItem, { backgroundColor: dropDownItemColor }]}
              onPress={() => {
                setGameSelected(item);
                setShowDropdown(false);
              }}
            >
              <Text style={styles.dropdownItemText}>
                {item === 'All'
                  ? 'All'
                  : `${operandText[GAME_TYPES_CONFIG[item].operation]} ${
                      GAME_TYPES_CONFIG[item].name
                    }`}
              </Text>
            </TouchableOpacity>
          )}
        />
      </View>
    </>
  );
}
const styles = StyleSheet.create({
  dropdownContainer: {
    marginTop: 5,
    padding: 6,
    backgroundColor: '#FFF9E6',
    borderRadius: 12,
    shadowColor: '#000',
    shadowOpacity: 0.05,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 4,
    elevation: 2,
    width: 220,
    position: 'absolute',
    maxHeight: 255,
    top: 30,
    borderWidth: 2,
    borderColor: '#FFCF53',
  },
  dropdownItem: {
    paddingVertical: 6,
    paddingHorizontal: 12,
    marginVertical: 4,
    borderRadius: 45,
    alignSelf: 'flex-start',
  },
  dropdownItemText: {
    fontFamily: 'Secular One',
    fontSize: 14,
    color: '#333333',
  },
});
